import script from "./CampaignsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsView.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsView.vue?vue&type=style&index=0&id=6d0f7ee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0f7ee2"]])

export default __exports__